import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './lib/useAuth';
import { signOut } from './lib/auth';
import { isAdmin } from './lib/admin';

export default function App() {
  const { pathname } = useLocation();
  const auth = useAuth();
  const hideChrome = pathname.startsWith('/editor/');

  return (
    <div className="flex min-h-full flex-col">
      {!hideChrome && (
        <header className="flex items-center justify-between border-b border-neutral-800 px-4 py-3">
          <Link to="/" className="font-semibold tracking-tight">
            Snippits
          </Link>
          <nav className="flex items-center gap-3 text-sm text-neutral-400">
            {auth.status === 'signed-in' ? (
              <>
                <Link to="/app" className="hover:text-neutral-100">
                  Library
                </Link>
                {isAdmin(auth.user.email) && (
                  <Link to="/admin" className="hover:text-neutral-100">
                    Admin
                  </Link>
                )}
                <span className="text-neutral-500">{auth.user.email}</span>
                <button onClick={() => signOut()} className="hover:text-neutral-100">
                  Sign out
                </button>
              </>
            ) : (
              <Link to="/signin" className="hover:text-neutral-100">
                Sign in
              </Link>
            )}
            <Link
              to="/install"
              className="rounded-md bg-brand-500 px-3 py-1.5 text-white hover:bg-brand-600"
            >
              Install extension
            </Link>
          </nav>
        </header>
      )}
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
